<div class="line-container">
  <canvas #lineChartCanvas class="lineChart"></canvas>
</div>
